import currencies from '../public/currencies.json';
import networks from '../public/networks.json';

const env = process.env.REACT_APP_ENV;

const additionalInfoMap = {
  bitcoincash: {
    explorerUrl: hash => env === 'production'
      ? `https://explorer.bitcoin.com/bch/tx/${hash}`
      : `https://www.blocktrail.com/tBCC/tx/${hash}`
  },
  bitcoinsv: {
    explorerUrl: hash => env === 'production'
      ? `https://blockchair.com/bitcoin-sv/transaction/${hash}`
      : null
  },
  bitcoingold: {
    explorerUrl: hash => env === 'production'
      ? `https://btgexplorer.com/tx/${hash}`
      : `https://testnet.btgexplorer.com/tx/${hash}`
  },
  vertcoin: {
    explorerUrl: hash => env === 'production'
      ? `https://insight.vertcoin.org/tx/${hash}`
      : null
  },
  dash: {
    explorerUrl: hash => env === 'production'
      ? `https://live.blockcypher.com/dash/tx/${hash}`
      : `https://chain.so/tx/DASHTEST/${hash}`
  },
  dogecoin: {
    explorerUrl: hash => env === 'production'
      ? `https://live.blockcypher.com/doge/tx/${hash}`
      : `https://chain.so/tx/DOGETEST/${hash}`
  },
  verge: {
    explorerUrl: hash => env === 'production'
      ? `https://verge-blockchain.info/tx/${hash}`
      : null
  }
};

const updatedCurrencies = currencies.map(currency => {
  const network = networks.find(n => n.servicePath === currency.servicePath);
  const networkEnv = env === 'production' ? 'mainnet' : 'testnet';

  const templateUrl = (hash, type) => {
    if (network.explorerUrls[networkEnv][type]) {
      return network.explorerUrls[networkEnv][type].replace('{{hash}}', hash);
    }
    return null;
  };

  if (network && network.explorerUrls && network.explorerUrls[networkEnv]) {
    currency.explorerUrl = hash => templateUrl(hash, 'transaction');
    currency.explorerAddressUrl = hash => templateUrl(hash, 'address');
  }

  if (additionalInfoMap[currency.protocol]) {
    currency = { ...currency, ...additionalInfoMap[currency.protocol] };
  }
  if (!currency.explorerUrl) {
    currency.explorerUrl = () => null;
  }

  if (!currency.explorerAddressUrl) {
    currency.explorerAddressUrl = () => null;
  }
  return currency;
});

export default updatedCurrencies;
export { networks };
